import { createAuthenticatedClient } from "./authenticated-client"

/**
 * Axios client configured for API communication.
 * Automatically attaches auth tokens and handles token refresh.
 */
export const apiClient = createAuthenticatedClient("/api", {
	contentType: "application/json",
})
